import { useEffect } from "react";
import { EstimatorWidget } from "./components/EstimatorWidget";
import { LegalFooter } from "./components/LegalFooter";
import { trackPageView } from "./lib/analytics";
import "./index.css";

export function App() {
  useEffect(() => {
    trackPageView();
  }, []);
  return (
    <div className="dashboard-grid flex min-h-screen w-full flex-col">
      <main className="flex flex-1 flex-col items-center px-4 pb-6 pt-6 sm:pt-10">
        <div className="mb-5 w-full max-w-lg">
          <div className="mb-3 flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-emerald-700">
              <svg className="h-4 w-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Local Registry Tool</p>
              <h1 className="text-lg font-bold text-slate-900 sm:text-xl">Pest &amp; Infestation Estimator</h1>
            </div>
          </div>
          <p className="text-xs leading-relaxed text-slate-500">
            Run localized diagnostic algorithms to estimate treatment costs and identify pest indicators. Find
            licensed field technicians and verify local pricing in your area.
          </p>
        </div>

        <div className="w-full max-w-lg">
          <EstimatorWidget />
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}

export default App;
